var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVentilatorBundle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13469_15782",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H23V23H1V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13469_15782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.46094 1.42969H16.8984C17.468 1.42969 17.9297 1.89139 17.9297 2.46094V21.5391C17.9297 22.1086 17.468 22.5703 16.8984 22.5703H2.46094C1.89139 22.5703 1.42969 22.1086 1.42969 21.5391V2.46094C1.42969 1.89139 1.89139 1.42969 2.46094 1.42969Z",
    fill: "#79B2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0456 3.14844H16.2109V20.8516H3.14844V18.1445V3.14844H6.31382",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36279 4.52344H11.9962C12.5005 4.52344 12.9093 4.11463 12.9093 3.61035V1.42969H6.44971V3.61035C6.44971 4.11463 6.85851 4.52344 7.36279 4.52344Z",
    fill: "#FF6977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9297 13.246V21.5389C17.9297 22.1085 17.468 22.5702 16.8984 22.5702H2.46094C1.89139 22.5702 1.42969 22.1085 1.42969 21.5389V2.46082C1.42969 1.89126 1.89139 1.42957 2.46094 1.42957H16.8984C17.468 1.42957 17.9297 1.89126 17.9297 2.46082V9.86184",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36279 4.52344H11.9962C12.5005 4.52344 12.9093 4.11463 12.9093 3.61035V1.42969H6.44971V3.61035C6.44971 4.11463 6.85851 4.52344 7.36279 4.52344Z",
    fill: "#BDD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36279 4.52344H11.9962C12.5005 4.52344 12.9093 4.11463 12.9093 3.61035V1.42969H6.44971V3.61035C6.44971 4.11463 6.85851 4.52344 7.36279 4.52344Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96094 20.8516H3.14844V18.1445V3.14844H6.31382",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2109 14.3633V20.8516H7.875",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0454 3.14849H16.2108V11.5179",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5959 12.196L20.6305 7.16142C21.0743 6.7176 21.7938 6.7176 22.2376 7.16142C22.6814 7.6052 22.6814 8.32476 22.2376 8.76854L17.2031 13.8031L14.3062 15.0929L15.5959 12.196Z",
    fill: "#FFC15A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2031 13.803L15.5959 12.1959L14.3062 15.0928L17.2031 13.803Z",
    fill: "#98A1B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6848 9.32092L22.2372 8.76847C22.6811 8.32465 22.6811 7.60514 22.2372 7.16131C21.7935 6.71753 21.0739 6.71753 20.6301 7.16131L20.0776 7.71376L21.6848 9.32092Z",
    fill: "#FF6977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6362 10.37L17.2031 13.8031L14.3062 15.0929L15.5959 12.196L20.6305 7.16138C21.0743 6.7176 21.7938 6.7176 22.2376 7.16138C22.6814 7.60516 22.6814 8.32476 22.2376 8.76854L20.6362 10.37Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1085 13.7089L15.6338 12.2342",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6848 9.32092L20.0776 7.71376",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96094 9.33594H5.21094V6.58594H7.96094V9.33594Z",
    fill: "#CBE558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96094 14.0625H5.21094V11.3125H7.96094V14.0625Z",
    fill: "#CBE558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96094 18.7891H5.21094V16.0391H7.96094V18.7891Z",
    fill: "#FF6977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96094 9.33594H5.21094V6.58594H7.96094V9.33594Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96094 14.0625H5.21094V11.3125H7.96094V14.0625Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96094 18.7891H5.21094V16.0391H7.96094V18.7891Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3848 7.97498L11.3407 8.93091L13.2805 6.99104",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3848 12.7015L11.3407 13.6575L13.2805 11.7176",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8623 18.384L12.8022 16.4442",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8623 16.4442L12.8022 18.384",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentilatorBundle);
export default __webpack_public_path__ + "static/media/ventilatorBundle.be4b4ae7eb591217207f0293b325acc0.svg";
export { ForwardRef as ReactComponent };